var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',[_c('h3',[_vm._v(_vm._s(_vm.resultMessage))]),_c('w-button',{staticClass:"btn-primary float-right",attrs:{"text":"Powrót do dokumentu"},on:{"click":_vm.goToDocumentDetails}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }